import React from "react";
import { Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekDatepicker } from "./inputs";
import { DATE_RANGE_FIELDS, invalidDateRanges, isApiDate, } from "../utils/dateRangeFilters";
import { API_DATE_FORMAT, DISPLAY_DATE_FORMAT, formatDate, } from "../utils/dateUtils";
var MSG = "ui-br-agency.filter.dateRange";
/**
 * Filter pane accordions "Datum založení" and "Datum poslední aktualizace", each with an Od and a
 * Do datepicker. Either bound may be used alone. Typed text that is not a valid date is reported
 * on its field, and an Od after Do on the Do field; the owning filter hook blocks Apply for both.
 */
export var DateRangeFilterAccordions = function (_a) {
    var values = _a.values, onChange = _a.onChange, invalidInputs = _a.invalidInputs, onInvalidInputChange = _a.onInvalidInputChange, inputsKey = _a.inputsKey, labelIds = _a.labelIds, idPrefix = _a.idPrefix;
    var formatMessage = useIntl().formatMessage;
    var invalidRanges = invalidDateRanges(values);
    // The Stripes Datepicker (outside react-final-form) reports the typed text and the backend
    // value, which is "" while the text is incomplete or not a real day. Such text never becomes a
    // filter value, but it is flagged so the user sees why Apply is blocked instead of the bound
    // being dropped silently.
    var handleChange = function (key) {
        return function (_event, typed, backendValue) {
            var isValid = !(typed === null || typed === void 0 ? void 0 : typed.trim()) || (!!backendValue && isApiDate(backendValue));
            onInvalidInputChange(key, !isValid);
            onChange(key, isValid && (typed === null || typed === void 0 ? void 0 : typed.trim()) ? backendValue : "");
        };
    };
    return (React.createElement(React.Fragment, null, DATE_RANGE_FIELDS.map(function (field) {
        var fromKey = "".concat(field, "From");
        var toKey = "".concat(field, "To");
        var from = values[fromKey];
        var to = values[toKey];
        var fieldLabel = formatMessage({ id: labelIds[field] });
        var boundAriaLabel = function (bound) {
            return formatMessage({ id: "".concat(MSG, ".ariaLabel") }, {
                field: fieldLabel,
                bound: formatMessage({ id: "".concat(MSG, ".").concat(bound) }),
            });
        };
        var invalidDateError = formatMessage({ id: "".concat(MSG, ".invalidDate") });
        var toError;
        if (invalidInputs[toKey])
            toError = invalidDateError;
        else if (invalidRanges[field])
            toError = formatMessage({ id: "".concat(MSG, ".toBeforeFrom") });
        return (React.createElement(Accordion, { key: field, id: "".concat(idPrefix, "-").concat(field), label: fieldLabel, separator: false, displayWhenClosed: from || to ? (React.createElement("div", null, [
                from &&
                    "".concat(formatMessage({ id: "".concat(MSG, ".from") }), " ").concat(formatDate(from)),
                to &&
                    "".concat(formatMessage({ id: "".concat(MSG, ".to") }), " ").concat(formatDate(to)),
            ]
                .filter(Boolean)
                .join(" "))) : undefined },
            React.createElement(RecekDatepicker, { key: "".concat(fromKey, "-").concat(inputsKey), id: "".concat(idPrefix, "-").concat(fromKey), labelId: "".concat(MSG, ".from"), ariaLabel: boundAriaLabel("from"), value: from, onChange: handleChange(fromKey), backendDateStandard: API_DATE_FORMAT, dateFormat: DISPLAY_DATE_FORMAT, error: invalidInputs[fromKey] ? invalidDateError : undefined, fullWidth: true }),
            React.createElement(RecekDatepicker, { key: "".concat(toKey, "-").concat(inputsKey), id: "".concat(idPrefix, "-").concat(toKey), labelId: "".concat(MSG, ".to"), ariaLabel: boundAriaLabel("to"), value: to, onChange: handleChange(toKey), backendDateStandard: API_DATE_FORMAT, dateFormat: DISPLAY_DATE_FORMAT, error: toError, fullWidth: true, marginBottom0: true })));
    })));
};
